import {
  TSdkIntlShape,
  EVENT_INTLCHANGE_TYPE,
  isIntlChangeEvent,
} from '@tokenized/sdk-js-private';
import { useEffect, useState } from 'react';
import { useTokenizedApi } from '../useTokenizedApi';

/** @category Internationalization */
export function useLocale() {
  const tokenizedApi = useTokenizedApi();
  const [locale, setLocale] = useState<string>(tokenizedApi?.intl.getLocale());

  useEffect(() => {
    if (tokenizedApi) {
      const updateLocale: EventListener = (event) => {
        if (isIntlChangeEvent(event)) {
          setLocale(event.detail.locale);
        }
      };
      tokenizedApi.intl.addEventListener(EVENT_INTLCHANGE_TYPE, updateLocale);
      return () =>
        tokenizedApi.intl.removeEventListener(
          EVENT_INTLCHANGE_TYPE,
          updateLocale,
        );
    }
  }, [tokenizedApi, tokenizedApi?.intl]);

  return locale;
}
